module.exports = __webpack_public_path__ + "static/img/14君得.27e99f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/14君得.jpg
// module id = WPJ4
// module chunks = 0